module.exports = __webpack_public_path__ + "static/anyinghuoju-5805a2accd6df6b9e2bdb9a160ea9534.jpg";